import { Intl } from "../../../state/helpers/IntlProps"
import { InventoryLocationQuantities, InventoryProductReorderResult } from "../../../state/inventory/data/model/inventoryData"
import { ImportStockDto } from "../../../state/inventory/imports/models"
import { NormalizedLocation } from "../../../state/inventory/location/reducers"
import { StockDocumentAttributes } from "../../../state/inventory/stockdocument/models"
import { PricingRowDto } from "../../../state/pricing/PricingRow"
import { ProductDto, ProductDtoAttributes } from "../../../state/product/Product"
import { VariantsIds } from "../../../state/product/pricingbrackets/PricingBrackets"
import { InventoryStockDirection } from "../../../utils/inventory"

export const INVENTORY_IMPORT_FILE_URL = "/files/update_imports.csv"
export const SUPPLIER_COSTS_IMPORT_FILE_URL = "/files/supplier_costs_import_template.csv"
export namespace INVENTORY_TAB {
    export const SETTINGS = "settings" as const
    export const STOCK_LOCATIONS = "stock-locations" as const
    export const DOCUMENT_TYPES = "documents-types" as const
    export const STOCK_CONTROL = "stock-control" as const
    export const IMPORTS = "imports" as const
    export const STOCK_DOCUMENTS = "stock-documents" as const
}

export type InventoryTab = typeof INVENTORY_TAB[keyof typeof INVENTORY_TAB]

export namespace INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS {
    export const DESCRIPTION = "description" as const
    export const STATUS = "status" as const
    export const TEMPLATE = "template" as const
}

export type InventoryStockDocumentDefinitionTab =
    typeof INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS[keyof typeof INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS]

export type NewStockMovementModalProps = {
    onCloseCallback: () => void
    definitionId?: string
    supplierId?: string
    intl: Intl
}

export type InventoryAdjustmentModalProps = {
    onCloseCallback: () => void
    direction: string
    intl: Intl
}

export type InventoryMovementStatusProps = {
    item: PricingRowDto
    direction: string
}

export type InventoryAdjustmentButtonProps = {
    buttonName: string
    direction: string
    documentDirection: string
    icon: string | undefined
}

export type StockImportFormAttributes = {
    inventoryLocation: string
    importType: string
    importFrom: string
    notes: string
    file: string
    integration: string
}

export type StockImportError = Omit<StockImportFormAttributes, "notes">

export type StockNewImportFormProps = {
    inventoryLocation: string
    importType: string
    notes: string
    errors: StockImportError
    importFrom: string
    integration: string
    onFormChangeCallback: (field: string, value: string) => void
}

export type ImportLocationOption = {
    value: string
    label: string
}

export type ImportAdjusmentListingProps = {
    importId: string
}

export type ProductInventoryQuantitiesProps = {
    product: ProductDto
    variantIds: VariantsIds[]
    productQuantities: InventoryLocationQuantities[]
    locations: NormalizedLocation[]
}

export type InventorySectionProps = {
    productId?: string
    product: ProductDto
}

export type AdjusmentListingProps = {
    productId: string
    product: ProductDto
    variantIds?: string[]
    locationId: string
}

export type ImportEditProps = {
    importId: string
}

export type ImportInfoProps = {
    import: ImportStockDto,
}

export type ImportStatusProps = {
    status: string,
    className: string
}

export type StockDocumentCostListingLabelProps = {
    item?: ProductDtoAttributes
    className?: string
    stockDocument?: StockDocumentAttributes
}

export namespace IMPORT_STOCK_FIELD {
    export const IMPORT_TYPE = "importType"
    export const STOCK_LOCATION = "inventoryLocation"
    export const NOTES = "notes"
    export const FILE = "file"
    export const IMPORT_FROM = "importFrom"
    export const INTEGRATION = "integration"

}

export type StockNewImportModalProps = {
    onShowModal: boolean
    onImportStartedCallback: (onShowModal: boolean) => void
    isModalChangedCallback: (onShowModal: boolean) => void
}

export namespace STOCK_IMPORT_STATUS {
    export const IN_PROGRESS = "in-progress"
    export const COMPLETED = "completed"
    export const CREATED = "created"
    export const ERROR = "error"
}

export type StockImportStatus = typeof STOCK_IMPORT_STATUS[keyof typeof STOCK_IMPORT_STATUS]

export type StockDirectionPlaceholderProps = {
    direction: InventoryStockDirection
}

export type AddFromOrderModalProps = {
    onCloseCallback: () => void
    supplierId?: string
    mainLocationIds: Array<string>
    intl: Intl
}

export type MainTabsProps = {
    enabledOverride?: boolean
}

export namespace STOCK_DOCUMENT_TYPE {
    export const VENDOR_RETURN = "Vendor Return"
    export const PURCHASE_ORDER = "Purchase Order"
    export const STOCK_ADJUSTMENT = "Stock adjustment"

}

export namespace STOCK_DOCUMENT_STATUS {
    export const DRAFT = "draft"
    export const IN_PROGRESS = "in-progress"
    export const COMPLETED = "completed"

}

export type ProductStockQuantitiesModalProps = {
    selectedModal: string
    productId: string
    locationId: string
    onCloseCallback: () => void
}

export type ReorderPointModalProps = {
    dataId: string
    onCloseCallback: () => void
    onSaveCallback: () => void
}

export type ReorderProductModalProps = {
    supplierId: string
    onCloseCallback: () => void
    reorderDetails: InventoryProductReorderResult
    intl: Intl
}

export type StockDocumentStatusSelectProps = {
    customStatusIds?: string[]
    onStatusChange: (value: string,label:string ) => void
}

export type FilterStatusOption = {
    label: string
    value: string
}


// WEBPACK FOOTER //
// ./src/common/types/inventory/types.ts